import { forwardRef } from 'react';
import { ThemedLinkButton } from '@Components/MuiWrappers/Button';
import { getDistinct, sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import Icon from '@mui/material/Icon';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import { useWindowSize } from '@Components/Utilities/WindowSize';

const CalculatorCurrencyBtn = forwardRef((props, ref) => {

    const routes = useRecoilValue(atoms.routes);
    const windowSize = useWindowSize();
    const saveAction = (e) => {
        sandhillsRequest({
            url: routes.SaveAction,
            method: 'post',
            data: {
                'email': '',
                'actionName': 'purchaseToday',
                'manufacturers': [props.Manufacturer],
                'models': [props.Model],
                'listingTypes': [props.ListingType],
                'categoryIDs': getDistinct([props.CategoryInformation.CategoryID, props.CategoryInformation.AltCategoryID]),
                'listingIDs': [props.ListingID],
                'conditions': [props.Condition]
            },
            errorHandling: {
                useConsole: false,
                useAlert: false
            }
        });

        props.OpenCalculator(e);
    }

    return (
        <>
            {props.Widgets.ShowLenderWidget &&
                <>
                    <ThemedLinkButton
                    variant='text'
                    size='small'
                    className='calc-button'
                    onClick={saveAction}
                    ref={(element) => { ref.current['finCalc'] = element }}
                    sx={{
                        width: '100%',
                        'justify-content': windowSize.isMobile ? 'center': 'left', 
                        'padding-inline': '0px',
                        'max-width': '180px'
                    }}
                    >
                        <Icon
                            baseClassName='fa'
                            className='fa-calculator calc-button__icon'
                            sx={{ marginRight: '5px' }}
                        />
                        <span
                            className='calc-button__text'
                            dangerouslySetInnerHTML={{ __html: props.Widgets.FinanceCalculatorDisplayText.replace('<strong>', '').replace('</strong>', '') }}
                        ></span>
                        <Icon baseClassName='fas' className='fa-external-link-alt calc-button__icon' />
                    </ThemedLinkButton>
                </>
            }
        </>
    );
});

export default CalculatorCurrencyBtn;